import { FetchModels, ViewsModels } from '../types';
import { convertReviewsPhoto } from './response-processor';

export const extractReviewsAllPhotos = (data: FetchModels.ReviewsResponse): ViewsModels.ReviewsPhoto[] => {
  let result: ViewsModels.ReviewsPhoto[] = [];
  if (data.product.review_photos instanceof Array) {
    try {
      result = data.product.review_photos.map(convertReviewsPhoto);
    } catch {
      result = [];
    }
  }

  return result;
};
